function hasText(value) {
    return value != null && String(value).trim() !== '';
}

export function isEmptyInspectionRow(row) {
    if (!row || row.mode === 'remove') {
        return false;
    }
    return (
        !hasText(row.requirement) &&
        !hasText(row.content) &&
        !hasText(row.specification) &&
        !hasText(row.remark)
    );
}

export function isEmptyTestRow(row) {
    if (!row || row.mode === 'remove') {
        return false;
    }
    return (
        !hasText(row.requirement) &&
        !hasText(row.equipment) &&
        !hasText(row.specification) &&
        !hasText(row.noOfPoint) &&
        !hasText(row.upperLimit) &&
        !hasText(row.lowerLimit) &&
        !hasText(row.remark)
    );
}

export function isEmptyMeasuringRow(row) {
    if (!row || row.mode === 'remove') {
        return false;
    }
    return (
        !hasText(row.pointToMeasure) &&
        !hasText(row.equipment) &&
        !hasText(row.Dimension) &&
        !hasText(row.UCL) &&
        !hasText(row.LCL) &&
        !hasText(row.requirement) &&
        !hasText(row.SPC) &&
        !hasText(row.CMK) &&
        !hasText(row.CPK)
    );
}

function prepareRowsForSave(rows, isEmptyRow) {
    return (rows || []).reduce((acc, row) => {
        if (row.mode === 'remove') {
            acc.push(row);
            return acc;
        }
        if (isEmptyRow(row)) {
            if (row.id) {
                acc.push({ ...row, mode: 'remove' });
            }
            return acc;
        }
        acc.push(row);
        return acc;
    }, []);
}

export function prepareInspectionsForSave(rows) {
    return prepareRowsForSave(rows, isEmptyInspectionRow);
}

export function prepareTestsForSave(rows) {
    return prepareRowsForSave(rows, isEmptyTestRow);
}

export function prepareMeasuringsForSave(rows) {
    return prepareRowsForSave(rows, isEmptyMeasuringRow);
}

export function isDuplicateRequirementRow(rows, requirement) {
    const key = hasText(requirement) ? String(requirement).trim() : '';
    if (!key) {
        return false;
    }
    return (rows || []).some(
        (row) => row.mode !== 'remove' && hasText(row.requirement) && String(row.requirement).trim() === key
    );
}
